import { CASES } from './constants';

/**
 * Action to update linked products in the store.
 *
 * This action is dispatched to update the linked products state in the Redux store.
 * It takes a payload containing the new linked products' data.
 *
 * @param {Object} payload - The new linked products data to be stored.
 * @returns {Object} The action object with type and payload.
 **/
export const updateLinkedProducts = (payload) => {
    return { type: CASES.UPDATE_LINKED_PRODUCTS, payload };
};

/**
 * Action to update the linked products filter form.
 *
 * This action is dispatched to update the filter form state in the Redux store.
 * It takes a key and data to update the specific field in the filter form.
 *
 * @param {string} key - The key of the filter form field to be updated.
 * @param {any} data - The new data to be set for the specified field.
 * @returns {Object} The action object with type and payload.
 **/
export const updateLinkedProductsForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_LINKED_PRODUCTS_FORM,
        payload: { key, data },
    };
};

/**
 * Action to clear the linked products filter form.
 *
 * This action is dispatched to reset the filter form state in the Redux store.
 * It clears all the fields in the filter form.
 *
 * @returns {Object} The action object with type and payload.
 **/
export const clearLinkedProducts = () => {
    return {
        type: CASES.CLEAR_LINKED_PRODUCTS,
        payload: { exclude: ['productOptions'] },
    };
};
